import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';

angular
  .module('capability-ng-appointments')
  .factory('appointmentsConfirmCommand', (defineCommand: IDefineCommand, QueryMediator: IQueryMediator): ICommand => {
    return defineCommand('appointmentsConfirmCommand', (deferred: ng.IDeferred<any>): void => {
      deferred.resolve();
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/appointments_confirm_command.ts